// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { signOutConnectedApplicationSession } from '@/account/api/sign-out-connected-application-session';
import { CONNECTED_APPLICATIONS_QUERY_KEY } from '@/account/constants/connected-applications';
import { useMutationWithGlobalErrorHandler } from '@/hooks/use-mutation-with-global-error-handler';
import { useQueryClient } from '@tanstack/react-query';

interface SessionToSignOut {
  applicationKey: string;
  sessionId: string;
}

/** Signs out of one session and shows the list of connected applications it answers with. */
export function useSignOutConnectedApplicationSession() {
  const queryClient = useQueryClient();

  return useMutationWithGlobalErrorHandler({
    mutationFn: (session: SessionToSignOut) =>
      signOutConnectedApplicationSession(
        session.applicationKey,
        session.sessionId
      ),
    errorMessage: 'The session could not be signed out.',
    onSuccess: (response) => {
      queryClient.setQueryData(CONNECTED_APPLICATIONS_QUERY_KEY, response);
    },
  });
}
